module.exports = __webpack_public_path__ + "img/index_domain.c3e2907f.png";